import { atom } from 'jotai';
import { Element_Base } from '~/common/typescript/models/Element';

export const elementsAtom = atom<Element_Base[]>([]);

export const elementSearchTextAtom = atom<string>('');

export const layerSearchTextAtom = atom<string>('');

export const selectedElementAtom = atom<Element_Base | null>(null);

export const elementDisplayedBoundsAtom = atom<string | null>(null);

export const showElementLabelsAtom = atom<boolean>(true); // Temporarily true for testing